import Vue from "vue"
import Router from "vue-router"
import store from '@/store.js'
import Oauth from "./views/Oauth.vue"
import Home from "./views/Home.vue"
import Tasks from "./views/Tasks.vue"
import Manipulative from "./views/Manipulative.vue"
import NotFound from "./views/404.vue"
import LoginGuard from "@/util/login-guard"
import Login from "./views/Login.vue"
import Pricing from "./views/Pricing.vue"
import Tutorials from "./views/Tutorials.vue"
import Resources from "./views/Resources.vue"
import Ideas from "./views/Ideas.vue"
import LoadShare from "@/views/LoadShare"

Vue.use(Router)

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      component: Home,
      beforeEnter: LoginGuard
    },
    {
      path: "/oauth",
      component: Oauth
    },
    {
      path: '/manipulatives',
      name: "manipulatives",
      component: Home,
      beforeEnter: LoginGuard
    },
    {
      path: '/pricing',
      component: Pricing,
      beforeEnter: LoginGuard
    },
    {
      path: '/tutorials',
      component: Tutorials,
      beforeEnter: LoginGuard
    },
    {
      path: '/resources',
      component: Resources,
      beforeEnter: LoginGuard
    },
    {
      path: '/ideas',
      component: Ideas
    },
    {
      path: '/tasks',
      component: Tasks,
      beforeEnter: LoginGuard
    },
    {
      path: '/s/:code?',
      component: LoadShare
    },
    {
      path: '/manipulatives/:manip_name/:shareCode?',
      name: 'manipulative-view',
      component: Manipulative,
      beforeEnter: LoginGuard
    },
    {
      path: "/logout",
      name: "logout",
      beforeEnter: (to, from, next) => {
        store.dispatch('logout');
        next({ path: '/login' });
      }
    },
    {
      path: "/login",
      name: "login",
      component: Login,
      beforeEnter: (to, from, next) => {
        const token = store.getters.token;

        if (token) {
          next({ path: '/' });
          return;
        } 

        next();
      }
    },
    {
      path: "/404",
      component: NotFound
    },
    {
      path: "*",
      component: NotFound
    }
  ]
});
